import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import authReducer from 'Features/auth/reducer'
import uiReducer from 'Features/ui/reducer'
import userReducer from 'Features/users/reducer'
import roomReducer from 'Features/rooms/reducer'
import fbsReducer from 'Features/fbs/reducer'
import buildingReducer from 'Features/buildings/reducer'
import fbsCategoryReducer from 'Features/fbsCategory/reducer'
import floorsReducer from 'Features/floors/reducer'
import rolesReducer from './features/roles/reducer'
import holidaysReducer from 'Features/holidays/reducer'
import amenityReducer from 'Features/amenity/reducer'
import settingReducer from 'Features/setting/reducer'
import titleReducer from 'Features/title/reducer'
import reportReducer from 'Features/report/reducer'
import roomformatReducer from 'Features/roomFormat/reducer'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    auth: authReducer,
    ui: uiReducer,
    user: userReducer.user,
    system: userReducer.system,
    localUsers: userReducer.localUsers,
    statusChangePassword: userReducer.statusChangePassword,
    sendMailResetPassword: userReducer.sendMailResetPassword,
    floors: roomReducer.floors,
    amenities: roomReducer.amenities,
    room: roomReducer.room,
    rooms: roomReducer.rooms,
    qrcode: roomReducer.qrcode,
    fbs: fbsReducer.fbs,
    fbsList: fbsReducer.fbsList,
    amenity: amenityReducer.amenity,
    amenityList: amenityReducer.amenityList,
    buildings: buildingReducer.buildings,
    building: buildingReducer.building,
    fbsCategory: fbsCategoryReducer.fbsCategory,
    floorsList: floorsReducer.floorsList,
    floor: floorsReducer.floor,
    rolesList: rolesReducer.rolesList,
    role: rolesReducer.role,
    setting: settingReducer.setting,
    holidays: holidaysReducer.holidays,
    holiday: holidaysReducer.holiday,
    title: titleReducer.title,
    titleList: titleReducer.titleList,
    disableRoom: roomReducer.disableRoom,
    executive: userReducer.executive,
    eventReport: reportReducer.eventReport,
    roomformats: roomformatReducer.roomformats,
    roomformat: roomformatReducer.roomformat,
    roomtype: roomReducer.roomtype,
    adminReport: reportReducer.adminReport,
    searchEvents: reportReducer.searchEvents,
    eventAction: reportReducer.eventAction,
    private_rooms: roomReducer.private_rooms,
    roomsByType: roomReducer.roomsByType
})



// WEBPACK FOOTER //
// ./src/reducers.js